import { Card } from "@components/ui-kit";
import { t } from "@lingui/macro";
import { CardTitle } from "../common";
import { PrepaymentList } from "./PrepaymentList";

export const PrepaymentCard = () => {
  return (
    <Card>
      <Card.Section>
        <CardTitle>{t`Prepayment`}</CardTitle>
        <PrepaymentList />
      </Card.Section>
    </Card>
  );
};
